export default __webpack_public_path__ + "static/media/4.b636f4f8.png";